import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { useCRMData } from '../context/CRMDataContext';

const Customers = () => {
  const { companies } = useCRMData();
  const navigate = useNavigate();

  const customers = useMemo(
    () => (Array.isArray(companies) ? companies.filter(company => company.status === 'Customer') : []),
    [companies]
  );

  return (
    <div className="p-8 max-w-7xl mx-auto min-h-screen bg-slate-50 space-y-10">
      <div className="pb-8 border-b border-slate-200">
        <h1 className="text-4xl font-black text-slate-900 tracking-tight">Kunder</h1>
        <p className="text-slate-500 font-medium text-lg mt-2">
          Selskaper som er registrert som kunder.
        </p>
      </div>

      {customers.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {customers.map((company) => {
            const companyId = company.company_id || company.id;

            return (
              <button
                key={companyId}
                type="button"
                onClick={() => navigate(`/companies/${companyId}`)}
                className="group text-left bg-white rounded-[2.5rem] border border-slate-200 p-8 hover:border-primary-300 shadow-sm hover:shadow-2xl hover:shadow-primary-500/10 transition-all duration-500"
              >
                <div className="flex items-start gap-5">
                  <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center border border-slate-100 shadow-sm overflow-hidden group-hover:scale-110 transition-transform duration-500">
                    {company.logo ? (
                      <img src={company.logo} alt={company.name} className="w-full h-full object-contain p-2" />
                    ) : (
                      <SafeIcon icon="🏢" className="text-3xl text-slate-300" />
                    )}
                  </div>
                  <div className="min-w-0">
                    <h2 className="text-xl font-black text-slate-900 leading-tight group-hover:text-primary-600 transition-colors">
                      {company.name || 'Ukjent selskap'}
                    </h2>
                    <span className="inline-flex mt-2 px-2.5 py-1 rounded-lg border border-emerald-100 bg-emerald-50 text-emerald-700 text-[10px] font-black uppercase tracking-widest">
                      Kunde
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-6 mt-8 border-t border-slate-100">
                  <div>
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Bransje</p>
                    <p className="text-sm font-bold text-slate-700 truncate mt-1">{company.industry || '—'}</p>
                  </div>
                  <div>
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Sted</p>
                    <p className="text-sm font-bold text-slate-700 truncate mt-1">{company.city || '—'}</p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      ) : (
        <div className="py-24 text-center bg-white rounded-[3rem] border-2 border-dashed border-slate-200">
          <SafeIcon icon="🏢" className="w-12 h-12 mx-auto text-slate-300 mb-5" />
          <h2 className="text-2xl font-black text-slate-900">Ingen kunder ennå</h2>
          <p className="text-slate-500 font-medium mt-2">
            Selskaper med status Kunde vil vises her.
          </p>
        </div>
      )}
    </div>
  );
};

export default Customers;